import { render } from "./S530_LieferantEinstellungen.vue?vue&type=template&id=255dfbb2&ts=true"
import script from "./S530_LieferantEinstellungen.vue?vue&type=script&lang=ts"
export * from "./S530_LieferantEinstellungen.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__